import { useProjectStore } from '../../stores/project.store';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from '@tanstack/react-router';

interface ProjectGuardProps {
  children: React.ReactNode;
}

export function ProjectGuard({ children }: ProjectGuardProps) {
  const { activeProjectId } = useProjectStore();
  const navigate = useNavigate();

  if (!activeProjectId) {
    return (
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography variant="h5" gutterBottom>
          No project selected
        </Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>
          Select an existing project or create a new one to get started.
        </Typography>
        <Button
          variant="contained"
          onClick={() => navigate({ to: '/projects' })}
        >
          Go to Projects
        </Button>
      </Box>
    );
  }

  return <>{children}</>;
}
